import {Component, Input, OnInit} from '@angular/core';
import {BaseProduct} from "../../../services/product.service";
import {AttachmentService} from "../../../services/attachment.service";
import {Utilities} from "../../../utils/utilities";
import {RestaurantService} from "../../../services/restaurant.service";

@Component({
  selector: 'app-slim-product',
  templateUrl: './slim-product.component.html',
  styleUrls: ['./slim-product.component.scss']
})
export class SlimProductComponent implements OnInit {
  @Input() model:BaseProduct;
  @Input() langCode:string;
  public collapseOne = true;
  restaurantHistoryIdsWithNames: any;

  constructor(private attachmentService:AttachmentService,
              private restaurantService: RestaurantService) { }

  ngOnInit() {
    Object.values<any>(this.model.attachments).forEach(prodAttachment =>{
      this.attachmentService.addExtraDataForOne(prodAttachment.attachment);
    });
    this.loadRestaurants();
  }

  loadRestaurants(){
    this.restaurantService.getOpenedRestaurants().subscribe(data => {
      data = this.restaurantService.addExtraDataForAll(data);
      let restHistNames = {};
      data.forEach(restaurant => {
        restHistNames[restaurant.historyId] = restaurant.name;
      });
      this.restaurantHistoryIdsWithNames = restHistNames;
    });
  }

}
